import { GuestInviteBar } from './GuestInviteBar.jsx';
import { Sidebar } from './Sidebar.jsx';
import { Workspace } from './Workspace.jsx';
import { MobileNav } from './MobileNav.jsx';

export function AppShell() {
  return (
    <div id="app-view" class="app" hidden>
      <GuestInviteBar />
      <Sidebar />
      <Workspace />
      <MobileNav />
    </div>
  );
}
